import { render, staticRenderFns } from "./Cited.vue?vue&type=template&id=60deee52&scoped=true&"
import script from "./Cited.vue?vue&type=script&lang=js&"
export * from "./Cited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60deee52",
  null
  
)

export default component.exports